<button
  class="button"
  [type]="type()"
  [disabled]="disabled() || loading()"
  [attr.data-size]="size()"
  [attr.data-style]="style()"
  [attr.data-outline]="outline()"
  (click)="buttonClick.emit($event)"
>
  <ng-content />

  @if (loading()) {
    <span class="loader"></span>
  }
</button>
